import { useEffect } from "react";
import { useParams } from "react-router-dom";
import Routes from "routing/Routes";
import useHistory from "routing/useHistory";
const NewSearchRedirectPage = () => {
  const history = useHistory();
  const { streamId } = useParams();
  useEffect(() => {
    if (streamId) {
      history.push(Routes.stream_search(streamId));
    } else {
      history.push(Routes.SEARCH);
    }
  }, [history, streamId]);
  return null;
};
export default NewSearchRedirectPage;
